<template>
  <section class="pases-banner py-5">
    <div class="overlay"></div>
    <div class="container position-relative">
      <div class="row align-items-center">
        <!-- Texto del banner -->
        <div class="col-lg-6 text-white mb-4 mb-lg-0">
          <h1 class="display-5 fw-bold fade-right">
            <i class="bi bi-calendar-check-fill text-warning me-2"></i>
            Agenda tu pase de entrenamiento gratuito
          </h1>
          <p class="lead mt-3 fade-right" style="animation-delay: 0.2s;">
            Victoria Gym te invita a disfrutar de <strong>1 día de entrenamiento gratuito</strong>.
            Sabemos que comenzar y mantener una rutina puede ser intimidante, por eso estamos aquí para ayudarte.
          </p>
          <p class="small text-warning fade-right" style="animation-delay: 0.4s;">
            Te enviaremos un correo con tu pase de cortesía 😊
          </p>
        </div>

        <!-- Formulario -->
        <div class="col-lg-6 fade-left" style="animation-delay: 0.6s;">
          <div class="card shadow-lg form-card p-4">
            <form @submit.prevent="submitForm" novalidate>
              <!-- Nombre y Apellido -->
              <div class="mb-3 input-group">
                <span class="input-group-text bg-warning text-white">
                  <i class="bi bi-person-fill"></i>
                </span>
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Nombre y Apellido *" 
                  v-model="form.name" 
                  required
                >
              </div>

              <!-- Cédula -->
              <div class="mb-3 input-group">
                <span class="input-group-text bg-warning text-white">
                  <i class="bi bi-credit-card-2-front-fill"></i>
                </span>
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Cédula venezolana *" 
                  v-model="form.document" 
                  maxlength="8"
                  pattern="\d{7,8}"
                  required
                >
              </div>

              <!-- WhatsApp -->
              <div class="mb-3 input-group">
                <span class="input-group-text bg-warning text-white">
                  <i class="bi bi-whatsapp"></i>
                </span>
                <input 
                  type="tel" 
                  class="form-control" 
                  placeholder="Número WhatsApp *" 
                  v-model="form.phone" 
                  maxlength="11"
                  pattern="\d{11}"
                  required
                >
              </div>

              <!-- Correo -->
              <div class="mb-3 input-group">
                <span class="input-group-text bg-warning text-white">
                  <i class="bi bi-envelope-fill"></i>
                </span>
                <input 
                  type="email" 
                  class="form-control" 
                  placeholder="Correo electrónico *" 
                  v-model="form.email" 
                  required
                >
              </div>

              <button type="submit" class="btn btn-warning w-100 fw-bold">
                <i class="bi bi-send-fill me-2"></i> Enviar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive } from 'vue'

const form = reactive({
  name: '',
  document: '',
  phone: '',
  email: '',
})

const submitForm = () => {
  if (
    !form.name ||
    !form.document.match(/^\d{7,8}$/) ||
    !form.phone.match(/^\d{11}$/) ||
    !form.email
  ) {
    alert('Por favor completa todos los campos correctamente.')
    return
  }

  // Mensaje con emojis compatibles
  const message = `🌟 *Hola Victoria Gym* 💪
Por favor quiero mi *pase de entrenamiento gratuito*. 🙌

📌 Aquí mis datos:

👤 *Nombre:* ${form.name}
🆔 *Cédula:* ${form.document}
📱 *WhatsApp:* ${form.phone}
📧 *Correo:* ${form.email}

🔥 Estoy listo(a) para comenzar mi entrenamiento y alcanzar mis metas con ustedes. ⚡
¡Gracias por su atención! 🙏`

  const waNumber = '584143516746'
  const waURL = `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`

  window.open(waURL, '_blank')
}
</script>

<style scoped>
/* Mantengo el mismo estilo que antes */
.pases-banner { position: relative; background: url('@/assets/images/carruzel/gym3.webp') no-repeat center center; background-size: cover; min-height: 100vh; display: flex; align-items: center; overflow: hidden; }
.overlay { position:absolute;top:0;left:0;right:0;bottom:0; background-color: rgba(0,0,0,0.55); z-index:0; }
.container.position-relative { z-index:1; }
.form-card { background: rgba(255,255,255,0.95); border-radius: 15px; transition: transform 0.3s ease, box-shadow 0.3s ease; }
.form-card:hover { transform: translateY(-5px) scale(1.01); box-shadow: 0 10px 25px rgba(0,0,0,0.25); }
.btn-warning { background-color: #F97316; border-color: #F97316; transition: transform 0.3s ease, box-shadow 0.3s ease; }
.btn-warning:hover { transform: scale(1.05); box-shadow: 0 4px 12px rgba(249,115,22,0.5); }
.fade-right, .fade-left { opacity: 0; transform: translateX(50px); animation: fadeInRight 0.8s forwards; }
.fade-left { transform: translateX(-50px); animation-name: fadeInLeft; }
@keyframes fadeInRight { to { opacity:1; transform:translateX(0); } }
@keyframes fadeInLeft { to { opacity:1; transform:translateX(0); } }
.input-group-text { border-radius: 0.5rem 0 0 0.5rem; }
@media (max-width: 992px) { .pases-banner { min-height: auto; padding: 3rem 1rem; } .fade-right, .fade-left { transform: translateX(0); opacity:1; animation:none; } }
</style>
